'use client';
import { FC } from 'react';
import Link from 'next/link';
import {
  BOOK_DEMO_HREF,
  SALES_DEMO_HREF,
} from '@/constants/publicConversionPaths';

const HeroSection: FC = () => {
  return (
    <section className='text-center pt-16 pb-28 px-4 sm:px-6 md:px-8 xl:px-10 bg-white'>
      <div
        className='
          mx-auto w-full max-w-none
          rounded-[20px]
          px-8 sm:px-12 md:px-16 lg:px-24
          py-24 md:py-36
          min-h-[700px] md:min-h-[760px] xl:min-h-[820px]
          flex flex-col items-center justify-center
          bg-no-repeat bg-cover bg-center
        '
        style={{
          backgroundImage: "url('/images/playbooks-cover.svg')",
        }}
      >
        <h1 className='mb-6 leading-tight font-medium text-[56px] sm:text-[64px] md:text-[76px] xl:text-[84px] text-black max-w-[1100px] mx-auto'>
          <span>Playbooks</span>{' '}
          <span>that you can put to </span>
          <span className='text-[#094FFE]'>work</span>{' '}
          <span>today!</span>
        </h1>
        <p className='text-[26px] sm:text-[28px] md:text-[30px] font-normal text-[#666666] max-w-[1200px] mx-auto'>
          Explore sales & marketing plays that can help you get promoted
        </p>
        <div className='mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row sm:flex-wrap'>
          <Link
            href={SALES_DEMO_HREF}
            className='inline-flex h-[50px] min-w-[210px] items-center justify-center rounded-[4px] bg-[#0848E7] px-[29px] text-base font-medium text-white transition-colors hover:bg-[#073dcc]'
          >
            Watch 4-minute demo
          </Link>
          <Link
            href={BOOK_DEMO_HREF}
            className='inline-flex h-[50px] min-w-[170px] items-center justify-center rounded-[4px] border border-[#0848E7] bg-white px-[29px] text-base font-medium text-[#0848E7] transition-colors hover:bg-[#0848E7]/5'
          >
            See it on your workflow
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
